export default __webpack_public_path__ + "img/fdb2bf503f69e2220a70d3cdbbeefe92.svg";